import images from "../../../images";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { cn } from "../../../Utils/helper";

const ContactUs = ({ linkNavigate = "", className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div
      onClick={linkNavigate === "" ? null : () => navigate(linkNavigate)}
      className={cn(
        "flex items-center justify-start w-full gap-[3px] mt-2 cursor-pointer",
        className
      )}
    >
      <img src={images.InfoIconGray} alt="" className="w-[14px] h-[14px]" />
      <p className="text-xs text-[#A0A0A0] font-medium">
        {t("historyWithdraw.contactUs")}
      </p>
    </div>
  );
};
export default ContactUs;
